<template>
  <div
    class="modal fade"
    id="videoModal"
    tabindex="-1"
    aria-labelledby="videoModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="videoModalLabel">{{ title }}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div v-if="link == ''" class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <iframe v-else
            class="w-100"
            :src="link"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "VideoModal",
  props: {
    title: String,
    link: String,
  },
  mounted() {
    const modalEl = document.getElementById("videoModal");
    if (modalEl) {
      modalEl.addEventListener("hidden.bs.modal", () => {
        this.$emit("close");
      });
    }
  },
};
</script>
<style scoped lang="css">
iframe {
  aspect-ratio: 560/315;
}
</style>
